import { resolveRoute } from '@/core/routing/resolve-route';
import { RouteResolver } from '@/core/types/route-resolver';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';
import CoreStore from '@/core/store';

const loanStore = getModule(LoanStore, store);
const coreStore = getModule(CoreStore, store);

export const loanRouteResolver = (...resolvers: RouteResolver[]) => resolveRoute({
	pre: () => {
		loanStore.setIsPageLoaderShown(true);
		loanStore.setIsPageErrorShown(false);
	},
	post: () => {
		window.scrollTo(0, 0);
		loanStore.setIsPageLoaderShown(false);
		coreStore.setIsPageLoaderShown(false);
	},
	errorHandler: (error: Error) => {
		loanStore.setIsPageLoaderShown(false);
		coreStore.setIsPageLoaderShown(false);
		loanStore.setIsPageErrorShown(true);
		console.error(error);
	},
	resolvers: [...resolvers],
});
